import {
  fetchImagingSchedulePending,
  fetchImagingScheduleSuccess,
  fetchImagingScheduleError,
} from "../redux/actions/ImagingScheduleActions";
import SuiteApi from "../api/SuiteApi";
import { Dispatch } from "redux";

export function fetchImagingSchedule() {
  return async (dispatch: Dispatch) => {
    dispatch(fetchImagingSchedulePending());
    try {
      const queuedPlates = await SuiteApi.getQueuedPlates();
      const scheduledPlates = await SuiteApi.getScheduledPlates();
      dispatch(fetchImagingScheduleSuccess(queuedPlates, scheduledPlates));
    } catch (error) {
      dispatch(fetchImagingScheduleError(error));
    }
  };
}
